.calendarHeader {
  --dch-control-size-xs: 30px;
  --dch-control-size-sm: 36px;
  --dch-control-size-md: 42px;
  --dch-control-size-lg: 48px;
  --dch-control-size-xl: 54px;
  --dch-control-size: var(--dch-control-size-sm);

  display: flex;
  max-width: calc(var(--dch-control-size) * 8 + rem(7px));
  margin-bottom: var(--mantine-spacing-xs);

  &[data-full-width] {
    max-width: none;
    width: 100%;
  }
}

.calendarHeaderLevel,
.calendarHeaderControl {
  height: var(--dch-control-size);
  border-radius: var(--mantine-radius-default);
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  opacity: 1;
  cursor: pointer;

  &:where([data-static]) {
    cursor: default;
  }

  @mixin hover {
    &:where(:not([data-disabled], [data-static], :disabled)) {
      @mixin light {
        background-color: var(--mantine-color-gray-0);
      }

      @mixin dark {
        background-color: var(--mantine-color-dark-5);
      }
    }
  }

  &:where(:disabled, [data-disabled]) {
    opacity: 0.2;
    cursor: not-allowed;
  }
}

.calendarHeaderControl {
  width: var(--dch-control-size);
}

.calendarHeaderLevel {
  flex: 1;
  font-size: var(--dch-fz, var(--mantine-font-size-sm));
  font-weight: var(--mantine-font-weight-medium);
  text-transform: capitalize;
}

.calendarHeaderLevel[data-native-level-select] {
  cursor: default;
  gap: var(--mantine-spacing-md);
}

.calendarHeaderSelect {
  appearance: none;
  background: transparent;
  border: none;
  font-size: var(--dch-fz, var(--mantine-font-size-sm));
  font-weight: var(--mantine-font-weight-medium);
  text-transform: capitalize;
  color: inherit;
  font-family: inherit;
  cursor: pointer;
  padding: 0;
  line-height: var(--dch-control-size);
  height: var(--dch-control-size);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 15' fill='none'%3E%3Cpath d='M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z' fill='currentColor' fill-rule='evenodd' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right center;
  background-size: rem(14px) rem(14px);
  padding-right: rem(16px);

  &:focus-visible {
    outline: rem(2px) solid var(--mantine-primary-color-filled);
    outline-offset: rem(2px);
    border-radius: var(--mantine-radius-sm);
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--mantine-color-dimmed);
  }
}

.calendarHeaderControlIcon {
  width: 60%;
  height: 60%;

  &:where([data-direction='next']) {
    transform: rotate(270deg);

    @mixin where-rtl {
      transform: rotate(90deg);
    }
  }

  &:where([data-direction='previous']) {
    transform: rotate(90deg);

    @mixin where-rtl {
      transform: rotate(270deg);
    }
  }
}
